//dependencies
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

//components
import AddFormModal from "../../../components/AddFormModal";
import PageTitle from "../../../components/PageTitle";
import ReviewTemplateModal from "../../../components/ReviewTemplateModal";
import ComponentLoader from "../../../components/Spinner/ComponentLoader";

//hooks
import { useEasyAddReviews, useUser } from "../../../api/hooks";
import useSearchQueryParams from "../../../hooks/useSearchQueryParams";
import useUserReviewsNavLinksAndPermissions from "./hooks/useUserReviewsNavLinksAndPermissions";

import FormsIDid from "./SubPages/FormsIDid";
//subpages
import FormsINeedToDo from "./SubPages/FormsINeedToDo";
import ReviewsOfMe from "./SubPages/ReviewsOfMe";
import ReviewsOfMyTeam from "./SubPages/ReviewsOfMyTeam";
//constants
import { USER_REVIEWS_CONFIG } from "./constants";

const UserReviews = () => {
	const navigate = useNavigate();
	const {
		activePage,
		isLoading,
		employeeId,
		userId,
		userCanViewFormsIDid,
		userCanViewFormsINeedToDo,
		userCanViewReviewsOfMe,
		userCanViewReviewsOfMyTeam,
		userCanCreateReviewForSubject,
	} = useUserReviewsNavLinksAndPermissions();
	const { data: employee } = useUser({ userID: employeeId, disabled: !employeeId });
	const [activeReviewTemplate, setActiveReviewTemplate] = useState(null);
	const { data: easyAddData, isLoading: isEasyAddLoading } = useEasyAddReviews(
		userId,
		employeeId || userId,
		{ limit: 10, skip: 0 },
		!userId
	);
	const { queryParams, handleQueryChange } = useSearchQueryParams({
		schema: USER_REVIEWS_CONFIG.queryParametersSchema,
	});

	const createReview = () => {
		handleQueryChange({ modal: null });

		// Prefill the subject only when the viewer can create a review for them; otherwise the
		// wizard opens with an empty picker rather than an unauthorized default.
		const subjectQuery = userCanCreateReviewForSubject ? `?subject=${employeeId}` : "";

		// get the url
		const nextUrl =
			activeReviewTemplate === null
				? `/start-review/${subjectQuery}`
				: `/start-review/${activeReviewTemplate}${subjectQuery}`;

		// update the url
		navigate(nextUrl);
	};
	const handleTemplateInputChange = (value) => {
		if (value === -1) {
			setActiveReviewTemplate("-1");
		}
		if (value !== "") {
			setActiveReviewTemplate(value);
		}
	};

	if (isLoading || isEasyAddLoading) {
		return <ComponentLoader />;
	}

	return (
		<>
			<PageTitle title={employee?.name ? `Reviews - ${employee?.name} - PerformYard` : "Employee Reviews"} />
			<div>
				{activePage === "forms-i-need-to-do" && userCanViewFormsINeedToDo && <FormsINeedToDo />}
				{activePage === "forms-i-did" && userCanViewFormsIDid && <FormsIDid />}
				{activePage === "reviews-of-me" && userCanViewReviewsOfMe && <ReviewsOfMe />}
				{activePage === "reviews-of-my-team" && userCanViewReviewsOfMyTeam && <ReviewsOfMyTeam />}
				{queryParams?.modal === "createReview" && (
					<ReviewTemplateModal
						handleTemplateInputChange={handleTemplateInputChange}
						handleModalCancel={() => handleQueryChange({ modal: null })}
						createReview={createReview}
					/>
				)}
				{queryParams?.modal === "add360Form" && (
					<AddFormModal
						userID={userId}
						employeeID={employeeId}
						handleClose={() => handleQueryChange({ modal: null })}
						reviews={easyAddData || []}
					/>
				)}
			</div>
		</>
	);
};

export default UserReviews;
